import { DefaultI18nValues } from './types';

export const defaultI18nEs: DefaultI18nValues = {
	'general.back': 'Voltar',
	'general.genericError.title':
		'Pedimos desculpa mas de momento não podemos satisfazer o seu pedido. Por favor tente mais tarde.',
};
